module.exports = __webpack_public_path__ + "img/sb04.ad2233b6.png";